const scrollToJumpPoint = (id: string): void => {
	// Finds the distance required to the target element exclusding any headers, banners and distance scrolled
	const targetElementYPosition = document.querySelector(id)?.getBoundingClientRect().top ?? 0;
	const headerHeight =
		document.querySelector(".sticky-header")?.getBoundingClientRect().height ?? 0;
	// We need to scroll to stop "early" to account for any header height or user scroll, this gets us our final #
	const finalOffset = targetElementYPosition - headerHeight + window.scrollY;
	if (targetElementYPosition) {
		window.scrollTo({ top: finalOffset, behavior: "smooth" });
	}
};

export const handleAnchorRowLinks = (
	anchorLinks: NodeListOf<HTMLButtonElement>,
	isReact?: boolean
): void => {
	anchorLinks.forEach((anchorLink) => {
		// This stops the event listener from being added twice locally
		if (anchorLink.classList.contains("react") && !isReact) return;
		const id: string = anchorLink.getAttribute("href")!;
		anchorLink.addEventListener("click", (event) => {
			event.preventDefault();
			scrollToJumpPoint(id);
		});
	});
};
